import React, { useEffect } from 'react';
import { planitem } from '../../json/PAAASItem';
import './paaas.css';

const Paaas2 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container container-mh'>
            <div className='row'>
                <h3 className='title'>Programa Anual de Adquisiciones, Arrendamientos y Servicios</h3>
                <hr className='hr-gob' />
            </div>
            <div className='row'>
                {
                    planitem.map((item, index) => (
                        <div key={index} className='col-md-4 col-sm-6 col-12 paaas_item'>
                            <a href={item.url} target="_blank">{item.anio}</a>
                            <hr class='row-separator'></hr>
                            <br></br>
                            <br></br>
                        </div>

                    ))
                }
            </div>
        </div>
    )
}

export default Paaas2